import { ApiChainSymbols } from '../../../utils/enums';

import { getIdFromUrl, isMobileDevice } from '@frontend/utils';
import { ArgSerializer, BigUIntValue } from '@multiversx/sdk-core';
import { parseUnits } from 'viem';
import { PaymentInstructionsDialogMethod } from '../../../components/PaymentInstructionsDialog/PaymentInstructionsDialog';
import { ApiCurrencySymbols } from '../../../utils/enums';

export const getMvxCallbackUrl = () => {
  return `${window.location.origin}/${getIdFromUrl()}`;
};

export const mapBlockchainToDialogMethod = (
  blockchain: ApiChainSymbols
): PaymentInstructionsDialogMethod => {
  if (
    blockchain === ApiChainSymbols.ETH ||
    blockchain === ApiChainSymbols.POLYGON ||
    blockchain === ApiChainSymbols.ERD ||
    blockchain === ApiChainSymbols.SOLANA
  ) {
    return 'wallet';
  }

  if (blockchain === ApiChainSymbols.BinancePay) {
    return 'binancePay';
  }

  if (blockchain === ApiChainSymbols['LN-BTC']) {
    return 'lightning';
  }

  if (blockchain === ApiChainSymbols.SOL) {
    return isMobileDevice() ? 'solanaPayMobile' : 'solanaPayDesktop';
  }

  return 'manual';
};

export const buildPaymentQRCodeURI = (
  blockchain: ApiChainSymbols,
  cryptoCurrency: string,
  address: string,
  cryptoAmount: string
) => {
  const buildBIP21URI = (chain: string, otherParams?: string) => {
    return `${chain}:${address}?amount=${cryptoAmount}${otherParams || ''}`;
  };

  switch (blockchain) {
    case ApiChainSymbols.ERD:
      if (cryptoCurrency.toLowerCase() === ApiCurrencySymbols.UTK) {
        const { argumentsString } = new ArgSerializer().valuesToString([
          new BigUIntValue(
            parseUnits(`${parseFloat(cryptoAmount)}`, 18).toString()
          ),
        ]);

        return buildBIP21URI(
          'multiversx',
          // the first part is token identifier (UTK-2f80e9)
          `&message=ESDTTransfer%4055544b2d326638306539%40${argumentsString}`
        );
      }
      return buildBIP21URI('multiversx');
    case ApiChainSymbols.BTC:
      return buildBIP21URI('bitcoin');
    case ApiChainSymbols.ETH:
      return buildBIP21URI('ethereum');
    default:
      return address;
  }
};

export const getIsEVM = (blockchain: ApiChainSymbols) =>
  [ApiChainSymbols.ETH, ApiChainSymbols.POLYGON].includes(blockchain);

export const getIsMvx = (blockchain: ApiChainSymbols) =>
  [ApiChainSymbols.ERD].includes(blockchain);

export const getIsSolana = (blockchain: ApiChainSymbols) =>
  blockchain === ApiChainSymbols.SOLANA;

export const getIsLightning = (blockchain: ApiChainSymbols) =>
  blockchain === ApiChainSymbols['LN-BTC'];

export const getIsBinancePay = (blockchain: ApiChainSymbols) =>
  blockchain === ApiChainSymbols.BinancePay;

export const getIsSolanaPay = (blockchain: ApiChainSymbols) =>
  blockchain === ApiChainSymbols.SOL;
